import { firebaseConfig, useEmulator } from "@repo/config";
import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage } from "firebase/storage";

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const useFirestoreEmulator =
  typeof process !== "undefined" &&
  // eslint-disable-next-line turbo/no-undeclared-env-vars -- The Partners dev script injects this public runtime flag outside Turbo.
  process.env.NEXT_PUBLIC_FIREBASE_USE_EMULATOR === "true";

// console.log("================================================");
// console.log(firebaseConfig);
// console.log(isProd);
// console.log("================================================");

const functionsInstance = getFunctions(app, "asia-northeast3");

// Initialize auth, db, storage first
const auth = getAuth(app);
const db = getFirestore(app);
let storage: ReturnType<typeof getStorage> | undefined;
try {
  storage = getStorage(app);
} catch {
  storage = undefined;
}

// Setup emulator if needed (after initialization)
if (useFirestoreEmulator) {
  try {
    connectFirestoreEmulator(db, "localhost", 8080);
  } catch {
    // The host app may already have connected this shared Firestore instance.
  }
}

if (useEmulator) {
  console.log("Using firebase emulator");
  import("firebase/functions").then(({ connectFunctionsEmulator }) => {
    connectFunctionsEmulator(functionsInstance, "localhost", 5001);
  });
}

const getCloudFunctionUrl = (path: string): string => {
  if (useEmulator) {
    return `http://localhost:5001/${functionsInstance.app.options.projectId}/asia-northeast3/${path}`;
  }
  return `https://${functionsInstance.region}-${functionsInstance.app.options.projectId}.cloudfunctions.net/${path}`;
};

const getOnCallFunction = (functionName: string) => {
  return httpsCallable(functionsInstance, functionName);
};

export {
  auth,
  db,
  storage,
  functionsInstance,
  getCloudFunctionUrl,
  getOnCallFunction,
};
